import Axios from "axios";

// axios配置
Axios.defaults.timeout = 10000;
Axios.defaults.baseURL = 'http://crm.chinatsi.net'; //http://192.168.124.9:8080
Axios.defaults.withCredentials = true;
Axios.defaults.headers = {
  'Content-Type': 'application/json'
}
// Axios.defaults.dataType = 'json';

/* 
  POST 方法
*/ 

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.post(url, data)
    .then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}

/* 
  application/x-www-form-urlencoded
*/

export function postByX (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.post(url, data, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
    .then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}

/* 
  PUT 方法
*/ 

export function put (url, data = {}) {
  return new Promise((resolve, reject) => {
    Axios.put(url, data)
    .then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}

/* 
  GET 方法 
*/

export function get (url, data) {
  return new Promise((resolve, reject) => {
    Axios.get(url, data).then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}
